module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"IT&I Internet-Technologien und Informationsverarbeitung-GmbH","short_name":"IT&I Software","start_url":"/","background_color":"#1d9fb3","theme_color":"#1d9fb3","display":"minimal-ui","icon":"src/images/iti-icon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["/services/","/technologies/","/about/","/careers/*"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-55},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
